import {FeatureFlags} from './types';

export const productionFeatureFlags: FeatureFlags = {
  isEnabledAccountSwitching: true,
  isEnabledPaymentLink: true,
  isEnabledWaitList: false,
  isEnabledBackToSchool: false,
  isSignInDisabled: true,
  isEnabledValidatePoBoxAddress: true,
  isEnabledRequestPhysicalCard: false,
};
